/* Brisket Friday List page: Klaviyo sign-up form + final CTA scroll.
   Config is read from data-* attributes set from section settings. */
(function () {
  var form = document.querySelector('[data-bf-form]');
  if (!form) return;

  var cfg = form.dataset;
  var emailEl = form.querySelector('[name="email"]');
  var phoneEl = form.querySelector('[name="phone"]');
  var trapEl = form.querySelector('[name="bf_company"]');
  var btn = form.querySelector('[type="submit"]');
  var statusEl = form.querySelector('[data-bf-status]');
  var fields = form.querySelector('[data-bf-fields]');
  var done = form.parentNode.querySelector('[data-bf-done]');
  var sending = false;

  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

  // Returns an E.164 number, '' for an empty field, or null when invalid.
  // US numbers get +1; numbers typed with a leading + are kept as international.
  function toE164(raw) {
    var v = (raw || '').trim();
    if (!v) return '';
    var digits = v.replace(/\D/g, '');
    if (v.charAt(0) === '+') return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null;
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length !== 10 || /^[01]/.test(digits)) return null;
    return '+1' + digits;
  }

  function fieldError(input, msg) {
    var err = document.getElementById(input.getAttribute('aria-describedby').split(' ')[0]);
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    err.textContent = msg || '';
    err.hidden = !msg;
  }

  function showStatus(msg) {
    statusEl.textContent = msg || '';
    statusEl.hidden = !msg;
  }

  // Moon Bundles patches window.fetch sitewide, so requests go through a clean iframe's fetch.
  var cleanFetch;
  function getFetch() {
    if (cleanFetch) return cleanFetch;
    try {
      var frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      document.body.appendChild(frame);
      var f = frame.contentWindow && frame.contentWindow.fetch;
      if (typeof f === 'function') cleanFetch = f.bind(frame.contentWindow);
    } catch (e) {}
    return cleanFetch || window.fetch.bind(window);
  }

  function subscribe(email, phone) {
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: email, subscriptions: subs };
    if (phone) {
      attrs.phone_number = phone;
      subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return getFetch()(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: cfg.revision },
        body: JSON.stringify(body)
      }
    ).then(function (res) {
      if (res.status >= 200 && res.status < 300) return;
      return res.text().then(function (t) {
        var err = new Error('Klaviyo ' + res.status);
        err.detail = t;
        throw err;
      });
    });
  }

  function trackLead(hasPhone) {
    var params = { form_id: 'brisket_friday_list', method: hasPhone ? 'email_sms' : 'email' };
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'generate_lead' }, params));
      else if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', params);
    } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Brisket Friday List' }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bf_generate_lead', params); } catch (e) {}
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (sending) return;
    showStatus('');

    var email = emailEl.value.trim();
    var phone = toE164(phoneEl.value);
    var ok = true;

    if (!EMAIL_RE.test(email)) {
      fieldError(emailEl, email ? cfg.errEmail : cfg.errEmailRequired);
      ok = false;
    } else fieldError(emailEl, '');
    if (phone === null) {
      fieldError(phoneEl, cfg.errPhone);
      ok = false;
    } else fieldError(phoneEl, '');
    if (!ok) {
      (emailEl.getAttribute('aria-invalid') === 'true' ? emailEl : phoneEl).focus();
      return;
    }
    // Bots fill the hidden field; pretend it worked.
    if (trapEl && trapEl.value) {
      fields.hidden = true;
      done.hidden = false;
      return;
    }

    sending = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = cfg.sendingLabel;

    subscribe(email, phone)
      .then(function () {
        fields.hidden = true;
        done.hidden = false;
        done.focus();
        trackLead(!!phone);
      })
      .catch(function (err) {
        if (window.console) console.warn('[bf] sign-up failed', err && err.message, err && err.detail);
        sending = false;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = cfg.buttonLabel;
        showStatus(cfg.errGeneric);
      });
  });

  [emailEl, phoneEl].forEach(function (input) {
    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true') fieldError(input, '');
    });
  });

  // Final CTA: smooth-scroll back to the hero form and focus the email field.
  document.querySelectorAll('[data-bf-jump]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('bf-signup');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var focusEl = done.hidden ? emailEl : done;
      setTimeout(function () { focusEl.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    });
  });
})();
